import { createStore } from "redux";
import pianoReducer from "./reducer";

const store = createStore(pianoReducer);

export default store;
